module.exports = __webpack_public_path__ + "img/advantage_3.00437b62.png";